<template>
  <div class="container-fluid">
    <b-overlay :show="showOverlay" rounded="sm">
      <b-card class="mt-2 col-12">
        <b-tabs>
          <b-tab
            v-for="tab in tabs"
            :key="tab.title"
            :title="tab.title"
            lazy
            @click.prevent="setActiveTabName(tab.mode)"
          >
            <b-col cols="12">
              <SearchFilter
                ref="searchFilter"
                :mode="tab.mode"
                @handleSubmit="searchFilterSubmit"
              />
            </b-col>
          </b-tab>
        </b-tabs>
      </b-card>

      <b-card v-for="tab in activeTab" :id="tab" :key="tab">
        <commonTable
          ref="tableCommon"
          :routeName="$route.name"
          :tableHeader="tableHeader"
          :searchMode="tab"
          @handleGroup="getManageGroup"
          @handleOverlay="setOverlay"
        >
          <b-tabs
            v-if="tabs.find((value) => value.mode === tab).subTabs.length > 0"
          >
            <b-tab
              v-for="subTab in tabs.find((value) => value.mode === tab).subTabs"
              :key="subTab.title"
              :title="subTab.title"
              lazy
              @click.prevent="
                setActiveTabSubName(
                  tabs.find((value) => value.mode === tab),
                  subTab.mode
                )
              "
            >
            </b-tab>
          </b-tabs>
        </commonTable>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BTabs,
  BTab,
  BButton,
  BCard,
  BCardHeader,
  BCardBody,
  BOverlay,
} from "bootstrap-vue";
import commonTable from "./components/commonTable.vue";
import commonTableHeader from "./components/commonTableHeader.js";
import SearchFilter from "./components/SearchFilter.vue";
import * as viewStore from "@/store/api/screening/screening.js";
import * as userData from "@/auth/localStorageUtils.js";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BTabs,
    BTab,
    BCard,
    BCardHeader,
    BCardBody,
    commonTable,
    SearchFilter,
    viewStore,
    BOverlay,
  },
  data() {
    return {
      tabs: [
        {
          title: "ข้อมูลการส่งเรื่องร้องทุกข์",
          mode: "Data",
          activeTab: ["Success"],
          subTabs: [
            { title: "ส่งเรื่องสำเร็จ", mode: "Success" },
            { title: "ส่งเรื่องไม่สำเร็จ", mode: "Fail" },
          ],
        },
      ],
      activeTab: ["Data"],

      tableHeader: commonTableHeader,
      showOverlay: false,
    };
  },
  methods: {
    setOverlay(isShow) {
      this.showOverlay = isShow;
    },
    setActiveTabName(name) {
      this.activeTab = [];
      this.activeTab.push(name);
    },
    setActiveTabSubName(tab, mode) {
      tab.activeTab = [];
      tab.activeTab.push(mode);
      this.$refs.searchFilter[0].onSearchBtnClicked();
    },
    getActiveTabSubName() {
      try {
        const _this = this;
        const activeTab = _this.tabs.find(
          (value) => value.mode === _this.activeTab[0]
        );
        if (activeTab.activeTab !== null && activeTab.activeTab !== undefined) {
          if (activeTab.activeTab.length > 0) {
            return activeTab.activeTab[0];
          }
        }

        return null;
      } catch (ex) {
        console.log("getActiveTabSubName ex", ex);
        return null;
      }
    },
    getManageGroup(id) {
      // if (this.activeTab[0] == "History") {
      //   const routeData = this.$router.resolve({
      //     name: "ComplaintHistoryDetail",
      //     query: { id },
      //   });
      //   window.open(routeData.href, "_blank");
      // } else {
      //   //(this.activeTab[0]=='List' || this.activeTab[0]=='Group')
      //   const routeData = this.$router.resolve({
      //     name: "ScreeningManage",
      //     query: { id },
      //   });
      //   window.open(routeData.href, "_blank");
      // }
    },
    searchFilterSubmit(params) {
      // params.userActive = params.userActive = userData.userId();
      // params.tabName = this.getActiveTabSubName();
      if (this.getActiveTabSubName() === "Success") {
        params.isSuccess = true;
      } else {
        params.isSuccess = false;
      }
      this.$refs.tableCommon[0].onSearchSubmit(params);
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
